import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import PicUpload from "@/components/picUpload/index.vue";
let imageSetting = class imageSetting extends Vue {
  constructor() {
    super(...arguments);
    this.postForm = {
      text: ""
    };
    this.rules = {
      text: [{
        required: true,
        message: "请输入描述说明",
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
    }
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], imageSetting.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], imageSetting.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], imageSetting.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], imageSetting.prototype, "watchPostForm", null);
imageSetting = __decorate([Component({
  name: "imageSetting",
  components: {
    questionSettingTemplate,
    PicUpload
  }
})], imageSetting);
export default imageSetting;